<script lang="ts">
  import { tick } from 'svelte'
  import Portal from 'svelte-portal'
  import { isMobileOrTablet } from '../../../utils'
  import AtomText from './AtomText.svelte'

  export let text: string
  export let show: boolean
  export let anchor: HTMLElement | null = null

  let tooltipElement: HTMLElement | null = null

  let position = {
    top: 0,
    left: 0,
  }

  $: updatePosition = async () => {
    await tick()

    if (anchor && tooltipElement) {
      const rect = anchor.getBoundingClientRect()
      position = {
        top: rect.top + window.scrollY - rect.height / 2 - 4,
        left: rect.left + window.scrollX + rect.width / 2,
      }
    }
  }

  $: updatePosition()
</script>

{#if show && anchor && !isMobileOrTablet()}
  <Portal>
    <div class="tooltipContainer" bind:this={tooltipElement} style="top: {position.top}px; left: {position.left}px">
      <div class="tooltip px-3 py-1 bg-gray-700 rounded-full">
        <div class="tooltipArrow" />
        <AtomText type="caption" color="white">{text}</AtomText>
      </div>
    </div>
  </Portal>
{/if}

<style>
  .tooltipContainer {
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 1000;
    pointer-events: none;
  }
  .tooltip {
    max-width: 200px;
    width: max-content;
    text-align: center;
  }
  .tooltipArrow {
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #374151; /* bg-gray-700 */
  }
</style>
